import type { FallacyName } from "@features/annogram/canvas/utils/argumentChecks";

/**
 * Maps each diagnostic the canvas can raise to the Learn page that
 * explains it.
 *
 * Deliberately separate from `learn.ts`: that module imports every
 * markdown page, and importing it from canvas code would drag the whole
 * Learn chunk (~190 kB) into the main bundle. This file holds names and
 * slugs only.
 *
 * Typed as a total Record over FallacyName, so adding a diagnostic
 * without giving it an explanation is a compile error rather than a
 * dead link.
 */
export interface PageLink {
  /** How the fallacy is named to the reader. */
  label: string;
  /** Slug of the page under /learn. */
  slug: string;
}

export const PAGE_FOR_FALLACY: Record<FallacyName, PageLink> = {
  begging_the_question: {
    label: "Begging the question",
    slug: "circular-reasoning-and-begging-the-question",
  },
  petitio_principii: {
    label: "Petitio principii",
    slug: "circular-reasoning-and-begging-the-question",
  },
  circular_reasoning: {
    label: "Circular reasoning",
    slug: "circular-reasoning-and-begging-the-question",
  },
  ignoratio_elenchi: {
    label: "Ignoratio elenchi",
    slug: "when-an-argument-succeeds",
  },
  ambiguous_conclusion: {
    label: "Ambiguous conclusion",
    slug: "when-an-argument-succeeds",
  },
};

export const pageForFallacy = (fallacy: FallacyName): PageLink =>
  PAGE_FOR_FALLACY[fallacy];
